class Forms {
    static recaptchaLoaded = false;
    static recaptchaLoading = false;
    static recaptchaCallbacks = [];

    constructor() {
        this.formFields = document.querySelectorAll('input:not([name="s"]), textarea, select');
        this.init();
    }

    init() {
        if (!this.formFields.length) return;

        const onFirstFocus = () => Forms.loadScript();

        this.formFields.forEach(field => {
            field.addEventListener('focus', onFirstFocus, { once: true });
        });
    }

    /**
     * Carrega o script do reCAPTCHA v3 de forma lazy.
     * Aceita um callback opcional que é executado após o script estar pronto.
     */
    static loadScript(callback) {
        if (Forms.recaptchaLoaded) {
            if (typeof callback === 'function') callback();
            return;
        }

        if (Forms.recaptchaLoading) {
            if (typeof callback === 'function') Forms.recaptchaCallbacks.push(callback);
            return;
        }

        Forms.recaptchaLoading = true;
        if (typeof callback === 'function') Forms.recaptchaCallbacks.push(callback);

        const script = document.createElement('script');
        // reCAPTCHA v3:
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(AppSettings.recaptchaSiteKey)}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            Forms.recaptchaLoaded = true;
            Forms.recaptchaLoading = false;

            Forms.recaptchaCallbacks.forEach(cb => typeof cb === 'function' && cb());
            Forms.recaptchaCallbacks = [];
        };

        script.onerror = () => {
            Forms.recaptchaLoading = false;
            console.error('Falha ao carregar o script do reCAPTCHA v3.');
            Forms.recaptchaCallbacks = [];
        };

        document.head.appendChild(script);
    }

    /**
     * Executa o reCAPTCHA v3, atualiza o campo hidden e dispara callback opcional.
     */
    static reloadCaptcha(action, fieldName = 'recaptcha_token', callback = null) {
        const exec = () => {
            const api = window.grecaptcha;

            if (!api) {
                console.warn('grecaptcha ainda não está disponível.');
                return;
            }

            api.ready(() => {
                api.execute(AppSettings.recaptchaSiteKey, { action })
                    .then(token => {
                        Forms.setToken(fieldName, token);
                        if (typeof callback === 'function') callback(token);
                    })
                    .catch(err => {
                        console.error('Erro ao executar reCAPTCHA v3:', err);
                    });
            });
        };

        Forms.loadScript(exec);
    }

    /**
     * Atualiza o valor do hidden com o token.
     */
    static setToken(fieldName, token) {
        const inputElement = document.querySelector(`input[name='${fieldName}']`);
        if (inputElement) inputElement.value = token;
    }

    /**
     * Inicialização simples para telas específicas (ex: homepage, contato, etc)
     */
    initializeReCaptcha(action = 'homepage') {
        Forms.reloadCaptcha(action, 'recaptcha_token');
    }

    /**
     * Mantida para compatibilidade, caso queira setar manualmente.
     */
    updateReCaptchaToken(token) {
        Forms.setToken('recaptcha_token', token);
    }
}

export default Forms;
window.reloadCaptcha = Forms.reloadCaptcha;
